module.exports = __webpack_public_path__ + "static/img/eccang.16af22d1.png";